export default __webpack_public_path__ + "static/media/ic_greenland.de0e4b6a.svg";